// src/components/ModoMantenimiento.js
import React from 'react';
import { Link } from 'react-router-dom';

const ModoMantenimiento = () => {
  return (
    <div className="mantenimiento-container">
      <div className="mantenimiento-card">
        <div className="mantenimiento-icon">🔧</div>
        <h1>Modo Mantenimiento</h1>
        <p>Estamos realizando mejoras en KREAMUN.</p>
        <p>Por favor, vuelve más tarde.</p>
        <Link to="/" className="btn btn-primary">Intentar de nuevo</Link>
      </div>
    </div>
  );
};

export default ModoMantenimiento;